export const OFFICE_ADDRESS =
    "Unit 9B, Galaxy Business Park, Blaydon-on-Tyne, NE21 4SQ, United Kingdom"

export const OFFICE_ADDRESS_SHORT =
    "Unit 9B, Galaxy Business Park, Blaydon-on-Tyne, NE21 4SQ"

export const MAPS_SEARCH_URL =
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent(OFFICE_ADDRESS)

export const MAP_EMBED_URL = `https://maps.google.com/maps?q=${encodeURIComponent(
    OFFICE_ADDRESS
)}&z=15&output=embed`
